/** Shahar telefonlari — SMS OTP faqat mobil raqamga. 70 va boshqa mobil prefikslar ruxsat. */
const LANDLINE_PREFIXES = new Set([
  '61', '62', '63', '64', '65', '66', '67', '68', '69',
  '71', '72', '73', '74', '75', '76', '78', '79',
]);

/**
 * @param {string} raw
 * @returns {string|null} 12 raqam 998XXXXXXXXX yoki null
 */
export function toDigits12(raw) {
  let digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return null;

  if (digits.length === 10 && digits.startsWith('0')) {
    digits = digits.slice(1);
  }
  if (digits.length === 9) {
    return `998${digits}`;
  }
  if (digits.length === 12 && digits.startsWith('998')) {
    return digits;
  }
  if (digits.startsWith('998') && digits.length > 12) {
    const tail = digits.slice(-12);
    if (tail.startsWith('998')) return tail;
  }
  if (digits.length === 13 && digits.startsWith('9988')) {
    const fixed = `998${digits.slice(4)}`;
    if (fixed.length === 12 && fixed.startsWith('998')) return fixed;
  }
  return null;
}

/**
 * @param {string} raw
 * @returns {boolean}
 */
export function isValidUzMobile(raw) {
  const d12 = toDigits12(raw);
  if (!d12) return false;
  const operator = d12.slice(3, 5);
  return !LANDLINE_PREFIXES.has(operator);
}

/**
 * Kirish / OTP: +998901234567 yoki 901234567 → +998901234567
 * @param {string} raw
 * @returns {string|null}
 */
export function normalizeLoginPhone(raw) {
  const d12 = toDigits12(raw);
  if (!d12 || !isValidUzMobile(d12)) return null;
  return `+${d12}`;
}

/**
 * UI: 9 ta mahalliy raqam (701884388) → +998701884388
 * @param {string} localDigits
 * @returns {string|null}
 */
export function normalizeLocalPhoneDigits(localDigits) {
  return normalizeLoginPhone(String(localDigits ?? '').replace(/\D/g, '').slice(0, 9));
}

/**
 * Chakana mijoz / nasiya uchun telefon — backend `RetailClientService::normalizePhoneDigits` bilan mos.
 * @param {string} raw
 * @returns {string|null} 12 raqam 998XXXXXXXXX yoki null
 */
export function normalizeRetailPhoneDigits(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length === 12 && digits.startsWith('998')) return digits;
  if (digits.length === 9) return `998${digits}`;
  if (digits.length >= 9) {
    const last9 = digits.slice(-9);
    if (last9.length === 9 && /^\d{9}$/.test(last9)) return `998${last9}`;
  }
  return null;
}
